import React from 'react';
// import PropTypes from 'prop-types';
import NotFoundPageTemplate from './not-found-page-template';

const NotFoundPage = () => (
  <NotFoundPageTemplate />
);

export default NotFoundPage;
